/**@jsx jsx */
import { jsx } from 'theme-ui'

export const WebAnalytics: React.FC = () => {
  if (typeof document === 'undefined' || typeof window === 'undefined')
    return null
  return (
    <img
      height="1"
      width="1"
      alt=""
      src={`/secure/utilities/wa.gif?r=${encodeURIComponent(
        document.referrer
      )}&u=${encodeURIComponent(
        window.location.href
      )}&m=GET&${window.location.search.substr(1)}`}
    />
  )
}
